/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../../components/Button';
import classes from './TileFooter.module.css';

const BUTTON_CONFIG = {
  pending: [
    { name: 'Notify', key: 'notify' },
    { name: 'In Progress', key: 'inProgress' },
  ],
  comingUp: [
    { name: 'Notify', key: 'notify' },
    { name: 'In Progress', key: 'inProgress' },
  ],
  inProgress: [
    { name: 'Notify', key: 'notify' },
    { name: 'Complete', key: 'complete' },
    { name: 'See Counter', key: 'seeCounter' },
  ],
  complete: [
    { name: 'Notify', key: 'notify' },
    { name: 'Picked Up', key: 'pickedUp' },
    { name: 'See Counter', key: 'seeCounter' },
  ],
  seeCounter: [
    { name: 'Notify', key: 'notify' },
    { name: 'Picked Up', key: 'pickedUp' },
    { name: 'Complete', key: 'complete' },
  ],
};

const TileFooter = ({ section, check, onFooterButtonPress }) => {
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    const btns = BUTTON_CONFIG[section?.key] || [];
    setButtons(btns);
  }, []);

  const onClickButton = actionType => {
    onFooterButtonPress && onFooterButtonPress(actionType, check);
  };

  return (
    <div className={classes.footerContainer}>
      {buttons.map(button =>
        <Button
          key={button.key}
          className={classes.actionButton}
          onClick={() => onClickButton(button.key)}>
          <span className={classes.buttonText}>{button.name}</span>
        </Button>
      )}
    </div>
  );
};

export default TileFooter;

TileFooter.propTypes = {
  section: PropTypes.object,
  onFooterButtonPress: PropTypes.func,
  check: PropTypes.object,
};

TileFooter.defaultProps = {
  section: {},
  onFooterButtonPress: () => { },
  check: {},
};
